import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function FooterSection() {
  return (
    <footer className="w-full bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="py-10 md:py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              BaseTao Spreadsheet Guide
            </h4>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Your independent resource for BaseTao Spreadsheet reviews, guides, and tutorials. We help shoppers stay organized and make smarter purchasing decisions.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                Home
              </Link>
              <Link
                to="/article/basetao-spreadsheet-guide"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                BaseTao Spreadsheet Guide
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                Main Store
              </a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              Shop Categories
            </h4>
            <nav className="flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                Shoes
              </a>
              <a
                href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                T-Shirts
              </a>
              <a
                href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                Jackets
              </a>
              <a
                href="https://kaspreadsheet.com/search-920/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-600 hover:text-foreground-900 text-sm transition-colors duration-200"
              >
                Accessories
              </a>
            </nav>
          </div>
        </div>

        <div className="py-5 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} BaseTao Spreadsheet Guide. All rights reserved.
          </p>
          <p className="text-foreground-500 text-xs">
            This is an independent educational resource. Not affiliated with BaseTao.
          </p>
        </div>
      </div>
    </footer>
  );
}